import { AuthenticatedDataRequest } from '@eggplant/data-request'
import { VAM_SERVICE } from '@eggplant/api-hosts'
import type { ReactElement } from 'react'

interface Props {
  suiteId: string
  localPath: string
  children?: (data: Blob) => ReactElement
}

// CRD-1356 suite images with the same name can be cached by the browser even if their content changes
const headers = {
  pragma: 'no-cache',
  'cache-control': 'no-cache'
}

const GetSuiteImageFileRequest = ({
  suiteId,
  localPath,
  children
}: Props) => {
  const url = `${VAM_SERVICE}/assets/${suiteId}/latest_version/files/${localPath}`

  return (
    <AuthenticatedDataRequest
      children={children}
      extraHeaders={headers}
      method='get'
      responseType='blob'
      url={url}
    />
  )
}

export default GetSuiteImageFileRequest
